import { crayon } from 'oderon-vue/utils'
import strCriteria from '@/views/beeper/subscriptions/str-criteria'
import { preProcessSpec } from 'oderon-commons/src/tables'

export const fullSpec = preProcessSpec({
  defCodes: ['id', 'email', 'name', 'criteria'],
  columns: [
    {
      t: 'ID|',
      d: 'id',
      f: crayon.grey,
      w: 100,
      selectable: true,
      sortable: false
    },
    {
      t: 'AccountId|',
      d: 'accountId',
      f: crayon.grey,
      w: 100,
      selectable: true,
      sortable: false
    },
    {
      t: '|Email',
      d: 'cachedEmail',
      c: 'email',
      selectable: true,
      sortable: false,
      w: 350
    },
    {
      t: '|Descrição',
      d: 'name',
      selectable: true,
      sortable: false,
      w: 200
    },
    {
      t: '|Regras',
      d: 'criteria',
      f: x => strCriteria(x, true),
      selectable: true,
      sortable: false
    },
    {
      t: 'Via Email?',
      d: 'viaEmail',
      selectable: true,
      sortable: false
    }
  ]
})
